import { generateId } from '@studio/models';
import type { Device } from '@studio/models/device';
import type {
  DeviceRegistryCommandFunctionType,
  DeviceRegistryCommandKey
} from '@tryiris-ai/common.protojs/api/v1/device_settings';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/** @internal */
export const focus = async (
  deviceId: Device['id'],
  [command, type]: [DeviceRegistryCommandKey, DeviceRegistryCommandFunctionType]
): Promise<void> => {
  try {
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      throw new Error('FX-G2W');
    }

    await proxy.mutate(
      {
        control: {
          device: {
            [deviceId]: {
              deviceSettings: {
                [command]: {
                  action: {
                    action: type,
                    uuid: generateId()
                  }
                }
              }
            }
          }
        }
      },
      {}
    );
  } catch (cause) {
    throw new StudioError('Unable to adjust focus.', { cause });
  }
};
